// Een filter dat van buiten een pagina wordt voorgezet.
//
// De chat en de redactiekaart wijzen allebei naar een tabblad mét een filter
// (`Landing.soort === "tab"`, contract api/redactie.schema.json). Dat filter is
// in het contract bewust losjes getypeerd — elk scherm kent zijn eigen assen —
// dus hier staat de vertaling van "onbekende waarde" naar iets waar een pagina
// zijn `useState` mee kan vullen.
//
// WAAROM DIT ERTOE DOET. De doorklik onder een chatantwoord zegt "bekijk alle
// 43 op de Skills-tab". Komt daar een ander getal in beeld, dan is het getal in
// de chat niet meer na te tellen en is de hele ingreep waardeloos. Deze
// helpers zijn dus geen gemak maar de plek waar dat één keer goed gaat.

export type Voorzet = Record<string, unknown>;

/** Een as die meervoudig is (categorie, status, uitgever, niveau). */
export function alsLijst(voorzet: Voorzet | null | undefined, sleutel: string): string[] {
  const waarde = voorzet?.[sleutel];
  if (Array.isArray(waarde)) return waarde.map(String).filter(Boolean);
  if (typeof waarde === "string" && waarde) return [waarde];
  return [];
}

/** Een as met één waarde (zoekterm, kind, datum). */
export function alsTekst(voorzet: Voorzet | null | undefined, sleutel: string): string {
  const waarde = voorzet?.[sleutel];
  return typeof waarde === "string" ? waarde : "";
}

/** Een aan/uit-as (quick wins). */
export function alsVlag(voorzet: Voorzet | null | undefined, sleutel: string): boolean {
  return voorzet?.[sleutel] === true;
}
